/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { StudentProgressReport } from './studentProgressReport';

export type GenericApiResponseStudentProgressReportData = StudentProgressReport | null;
